import { formatInTimeZone, fromZonedTime, toZonedTime } from 'date-fns-tz';

/**
 * Convert the value of a native datetime-local input (e.g. "2026-08-11T18:00",
 * interpreted as a wall-clock time in the given IANA tz) into a UTC ISO string
 * the API expects.
 */
export function zonedInputToUtcIso(value: string, ianaTz: string): string {
  const utcDate = fromZonedTime(value, ianaTz);
  return utcDate.toISOString();
}

/**
 * Inverse of zonedInputToUtcIso — take a UTC ISO string and return the
 * `yyyy-MM-ddTHH:mm` string to pre-fill a datetime-local input.
 */
export function utcIsoToZonedInput(utcIso: string, ianaTz: string): string {
  return formatInTimeZone(new Date(utcIso), ianaTz, "yyyy-MM-dd'T'HH:mm");
}

/** Render a UTC ISO timestamp in the market's timezone for display. */
export function formatInMarketTz(utcIso: string, ianaTz: string, pattern = 'PP p'): string {
  return formatInTimeZone(new Date(utcIso), ianaTz, pattern);
}

/** Return the day-of-week index (0 = Mon … 6 = Sun) at a UTC instant in a given tz. */
export function isoWeekdayInTz(utcDate: Date, ianaTz: string): number {
  const zoned = toZonedTime(utcDate, ianaTz);
  const js = zoned.getDay(); // 0 = Sun … 6 = Sat
  return (js + 6) % 7;        // shift so 0 = Mon … 6 = Sun
}
